<div class="c-container">
    <div class="c-container__header">
      <img src="../../../../assets/madero-logo.svg" alt="" srcset="" />
      <h1>Termos e Condições de Uso</h1>
      <hr />
    </div>
    <div class="c-container__content">
      <main>
        <div>
          <p>
            POR FAVOR, LEIA COM ATENÇÃO ESTES TERMOS ANTES DE ACESSAR OU USAR OS
            SERVIÇOS DISPONÍVEIS NESTA PLATAFORMA. A CONTINUAÇÃO DA NAVEGAÇÃO NAS
            PLATAFORMAS DO GRUPO MADERO E FRUIÇÃO DE TODAS AS SUAS FUNCIONALIDADES
            DEPENDE DA SUA ACEITAÇÃO AOS PRESENTES TERMOS E CONDIÇÕES DE USO E À
            POLÍTICA DE PRIVACIDADE DO GRUPO MADERO.
          </p>
          <h1>1. Atenção!</h1>
          <p>
            Certifique-se de ter lido e entendido as disposições aqui contidas
            antes de iniciar a utilização do aplicativo e/ou website
            (“Plataforma”). O aceite às condições aqui contidas é essencial para
            que possa acessar os serviços e produtos do Grupo Madero, via
            Plataforma. Caso não esteja de acordo, infelizmente, não será possível
            usufruir dos serviços disponíveis por meio desse canal.
          </p>
          <h1>2. Definições:</h1>
          <ul>
            <li>
              Os termos iniciados em letras maiúsculas terão os significados
              especificados na Política de Privacidade, exceto se de outra forma
              aqui e/ou na Política de Privacidade previsto.
            </li>
            <li>
              Sempre que as palavras “incluir”, “inclui”, “inclusive” ou
              “incluindo” são utilizadas neste Termo e Condição de Uso, elas
              deverão ser interpretadas como sendo sucedidas pelas palavras “sem
              limitação”.
            </li>
            <li>
              Qualquer referência a leis pressupõe o texto da lei e toda
              legislação complementar relacionada àquela lei em vigor na data da
              emissão deste Termo. Qualquer alteração legal deverá gerar os
              ajustes adequados neste Termo mas sempre de acordo com seus
              preceitos básicos, conforme definido pelo Grupo Madero.
            </li>
          </ul>
          <h1>3. O que significa este Termo e Condição de Uso (“Termo”)?</h1>
          <p>
            Este Termo regula o relacionamento entre você, Cliente, e o Grupo
            Madero na interação mantida por meio da Plataforma que você está
            acessando. Após a manifestação da sua “Ciência” e “Aceite”, esse
            instrumento oficializará a nossa relação, que é entendida pelo
            direito, como uma relação contratual e comercial, mas que significa
            muito mais para o Grupo Madero!
          </p>
          <p>
            Infelizmente, caso você não esteja de acordo com as condições aqui
            descritas ou descritas na Política de Privacidade, não será possível
            acessar os serviços e produtos disponibilizados pelo Grupo Madero, via
            Plataforma.
          </p>
          <p>
            O Grupo Madero se reserva o direito de alterar o presente Termo, bem
            com a Política de Privacidade autonomamente e a qualquer momento,
            sendo, portanto, a última versão publicada aquela que regulará o nosso
            relacionamento, mantido por meio desta Plataforma, sendo que, a
            simples utilização da Plataforma após qualquer atualização/modificação
            deste Termo e da Política de Privacidade constitui sua aceitação e sua
            concordância com a versão mais recente.
          </p>
          <p>
            É possível que você manifeste a sua oposição a quaisquer modificações
            no Termo, desde que o faça por escrito, por meio do canal indicado no
            item 10 abaixo, ocasião em que o seu cadastro será inativado.
          </p>
          <h1>4. Cadastro:</h1>
          <p>
            Para que você possa desfrutar dos nossos produtos e serviços,
            precisaremos coletar alguns dados cadastrais seus, conforme indicado
            no formulário para cadastro, disponível na Plataforma. De antemão, te
            asseguramos que o Grupo Madero, por meio de seus processos de negócio,
            entende, respeita e protege os dados pessoais de todos os Clientes, e
            que está comprometido em ser transparente e claro quanto às
            informações relativas ao tratamento dos dados pessoais que são por
            você compartilhados conosco. Para mais informações, confira a nossa
            Política de Privacidade!
          </p>
          <h1>5. O que você precisa saber?</h1>
          <p>
            Para o Cliente utilizar os serviços acima descritos, deverá ser
            juridicamente capaz ou estar legalmente representado para aderir e se
            vincular ao presente Termo. As suas informações pessoais para fins de
            verificação da sua capacidade e/ou regularidade da sua representação
            poderão ser conferidas, a qualquer momento, pelo Grupo Madero.
          </p>
          <p>
            Caso a Plataforma fique indisponível, o Grupo Madero não medirá seus
            esforços para que ela retorne o quanto antes à normalidade.
          </p>
          <p>
            O Grupo Madero se reserva ao direito de interromper os serviços ou
            qualquer funcionalidade da Plataforma, ao seu exclusivo critério, sem
            que seja assegurado ao Cliente qualquer aviso prévio.
          </p>
          <h1>5.1. Quem administra a conta do Cliente?</h1>
          <p>
            A conta de cada Cliente será administrada pelo Grupo Madero ou por
            pessoa que ele designar, portanto, em caso de informações incorretas,
            inverídicas, não confirmadas, ou na hipótese da negativa do Cliente em
            corrigi-las ou mesmo em caso de não confirmação com documentação
            pertinente, o Grupo Madero se reserva o direito de não concluir o
            cadastro, podendo, ainda, bloquear cadastro existente, impedindo o
            Cliente de utilizar a Plataforma até que, ao exclusivo critério do
            Grupo Madero, a situação seja regularizada.
          </p>
          <p>
            O Grupo Madero se reserva o direito de impedir, a seu exclusivo
            critério, novos cadastros, ou cancelar os já efetuados, caso seja
            detectada irregularidade que, em sua análise, seja grave ou constitua
            tentativa de burlar as regras deste Termo ou nos casos de
            descumprimento, pelo Cliente, de qualquer obrigação aqui prevista.
          </p>
          <h1>5.2. Como funciona o cadastro?</h1>
          <p>
            O Cliente que deseje acessar esta Plataforma, não precisa
            obrigatoriamente realizar o cadastro, somente precisará fazê-lo para a
            realização de pedidos e/ou aproveitar as vantagens do Programa de
            Fidelidade do Grupo Madero ou demais funcionalidades exclusivas da
            Plataforma.
          </p>
          <p>
            Uma vez efetuado o cadastro, o Cliente terá acesso a Plataforma por
            meio de login e senha. Tais dados são pessoais e intransferíveis, de
            modo que o Cliente deve comprometer-se a não os divulgar a terceiros,
            ficando sob sua exclusiva responsabilidade qualquer solicitação que
            seja feita com o uso de login e senha de sua titularidade.
          </p>
          <p>
            Caso você se esqueça os dados de validação ou caso seja verificado o
            uso indevido ou suspeito deles, deverá informar, imediatamente, o
            ocorrido ao Grupo Madero por intermédio da opção “esqueceu sua senha”,
            no caso de esquecimento, ou, por meio de uma comunicação realizada no
            “Fale Conosco” (indicado no item 10 abaixo) no caso de identificação
            de uso indevido ou suspeito.
          </p>
          <p>
            A Plataforma do Grupo Madero não se destina a menores de 18 (dezoito)
            anos de idade. Assim, caso você não possua a idade mínima exigida, não
            deverá utilizá-la sem a representação de seus pais, tutores ou
            curadores, na forma da lei.
          </p>
          <p>
            Já para o Cliente menor de 18 (dezoito) anos de idade, indicamos que
            não será possível encomendar e/ou adquirir, em qualquer hipótese,
            produtos alcoólicos, responsabilizando-se o Cliente pela correta
            informação de sua idade quando da realização do cadastro.
          </p>
          <h1>7. Limitações de Responsabilidade</h1>
          <p>
            O Grupo Madero não se responsabiliza pelo conteúdo publicado pelos
            Clientes, podendo, portanto, excluir ou limitar a publicação de
            qualquer material que, entre outras hipóteses: (i) não corresponda com
            o objetivo da Plataforma; (ii) contenha dados e/ou informações
            inverídicas; (iii) possua qualquer conteúdo ilícito; (iv) promova
            qualquer tipo de preconceito ou discriminação; (v) afronte a moral ou
            os bons costumes.
          </p>
          <p>
            O Cliente é corresponsável pelo sigilo de suas informações pessoais. O
            compartilhamento, pelo titular, de logins, senhas ou qualquer tipo de
            credencial não é recomendado.
          </p>
          <h1>8. Propriedade Intelectual</h1>
          <p>
            As marcas (incluindo logotipos), nomes, nomes de domínio e demais
            sinais distintivos, bem como todo e qualquer texto, conteúdo, desenho,
            arte ou layout publicado na Plataforma, são de propriedade exclusiva
            do Grupo Madero. Fica desde já certo que nenhum conteúdo constante na
            Plataforma deve ser interpretado como gratuito, de livre uso ou em
            domínio público ou pressupõe qualquer outra forma de licença ou
            direito de uso.
          </p>
          <p>
            São vedados quaisquer atos ou contribuições tendentes à modificação
            das características, ampliação, alteração, mesclagem ou incorporação
            em quaisquer outros programas ou sistemas.
          </p>
          <p>
            Enfim, toda e qualquer forma de reprodução, total ou parcial,
            permanente, temporária ou provisória, de forma gratuita ou onerosa,
            sob quaisquer modalidades, formas ou títulos da Plataforma, sem a
            prévia e expressa autorização do Grupo Madero, é totalmente vedada e
            será considerada para todos os fins violação à propriedade intelectual
            do Grupo Madero.
          </p>
          <h1>9. Cancelamento e Suspensão do Cadastro</h1>
          <p>
            O Grupo Madero se reserva ao direito de cancelar, suspender,
            desativar, bloquear ou, encerrar unilateralmente o acesso do Cliente à
            Plataforma, caso: (i) suas ações violem às disposições deste Termo;
            (iii) se o Cliente causar algum dano direto ou indireto ao Grupo
            Madero, demais Clientes ou a terceiros; (iv) seja identificada, de
            forma direta ou indireta, a prática de atitudes fraudulentas através
            do uso da Plataformas; (vi) em outros casos onde o Grupo Madero
            entenda necessário, por violação de normas jurídicas,
            incompatibilidade com este Termo, entre outras, a critério exclusivo
            do Grupo Madero./p>
          </p>
          <h1>10. Caso tenha dúvidas</h1>
          <p>
            Em caso de dúvidas, estamos à sua inteira disposição, por meio do
            nosso “Fale Conosco”, disponível pelos aplicativos do Grupo Madero,
            MADERO, JERONIMO e GRUPO MADERO e nos seguintes canais:
          </p>
          <table border="1">
            <thead>
              <tr>
                <th>Plataforma</th>
                <th>E-mail SAC</th>
                <th>Privacidade</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>MADERO</td>
                <td rowspan="4">relacionamento&commat;grupomadero.com.br</td>
                <td rowspan="4">privacidade&commat;grupomadero.com.br</td>
              </tr>
              <tr>
                <td>JERONIMO</td>
              </tr>
              <tr>
                <td>PROGRAMA FIDELIDADE</td>
              </tr>
              <tr>
                <td>ECO PARADA MADERO</td>
              </tr>
            </tbody>
          </table>
          <h1>11. Foro</h1>
          <p>
            Fica eleito o foro Central da Comarca da Região Metropolitana de
            Curitiba, estado do Paraná, como competente para dirimir quaisquer
            dúvidas oriundas do presente Termo, com exclusão de qualquer outro,
            por mais privilegiado que seja.
          </p>
          <h1>12. Aceitação Total</h1>
          <p>
            O Cliente declara seu CONSENTIMENTO expresso dos termos constantes
            neste Termo, sendo que aceita a totalidade das situações nele
            regulada.
          </p>
          <table border="1">
            <thead>
              <tr>
                <th>DATA</th>
                <th>DESCRIÇÃO</th>
                <th>AUTOR</th>
                <th>VERSÃO</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>13/09/2021</td>
                <td>Criação do documento</td>
                <td>Dir.Jurídica</td>
                <td>1.0</td>
              </tr>
              <tr>
                <td>12/05/2023</td>
                <td>Atualização do documento</td>
                <td>Dir.Juridica</td>
                <td>1.1</td>
              </tr>
              <tr>
                <td>19/02/2024</td>
                <td>Atualização do documento</td>
                <td>DPO</td>
                <td>1.2</td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>
    </div>
  </div>
  